import {
    DEFAULT_OG_PATH,
    imageAlt,
    metaDescription,
    placeSlug,
    profileTitle,
    seoSlug,
    SITE_DESCRIPTION,
} from '../../../shared/seoCopy.js';

export {
    DEFAULT_OG_PATH,
    imageAlt,
    metaDescription,
    placeSlug,
    profileTitle,
    seoSlug,
    SITE_DESCRIPTION,
};

/** Members search. Visitors open the public directory page for that skill. */
export function skillChipHref(label: string | undefined, signedIn: boolean): string {
    const name = (label || '').trim();
    if (signedIn) return `/search?query=${name}`;
    const slug = seoSlug(name);
    return slug ? `/directory/${slug}` : '/directory';
}
